import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import type {SelectMenuOption} from 'shells/action-menu/action-menu';
import {Card} from 'shells/card/card';
import {Link} from 'shells/link/link';
import {ThumbnailContent} from 'shells/thumbnail/thumbnail-content/thumbnail-content';

import {getAudienceSubtitle, getPublicAudienceElement} from './helpers';

type Props = {
    deletedTime: number | null | undefined;
    htmlUrlPath: string;
    name: string;
    actionMenuOptions: SelectMenuOption[];
    subscribersCount: number | null | undefined;
    publicName: string;
    publicDescription: string;
};

export function PublicAudienceListCard(props: Props) {
    return (
        // @ts-expect-error
        <Card fitHeight={true} isFullWidth={true} hasBorder={true} backgroundColor='white'>
            <ThumbnailContent
                title={
                    // @ts-expect-error
                    <Link as={RouterLink} variant='primary' size='normal' to={props.htmlUrlPath}>
                        {props.name}
                    </Link>
                }
                secondaryInfo={getAudienceSubtitle({
                    subscribersCount: props.subscribersCount,
                    isPublic: false, // Even though this is true, we don't want to show it here
                    deletedTime: props.deletedTime,
                })}
                tertiaryInfo={getPublicAudienceElement(props.publicName, props.publicDescription)}
                options={props.actionMenuOptions}
            />
        </Card>
    );
}
